import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enResource from '../locales/en/Resources.json';
import svResource from '../locales/sv/Resources.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'localStorage', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 10,
      cookieOptions: { path: '/' },
      htmlTag: document.documentElement
    },
    debug: false,
    ns: ['resources'],
    defaultNs: 'resources',
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    load: 'languageOnly',
    lngWhiteList: ['en', 'sv'],
    fallbackLng: 'sv',
    resources: {
      en: enResource,
      sv: svResource
    }
  });

export default i18n;
